import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=72e45768&scoped=true&"
import script from "./MemberDetail.vue?vue&type=script&lang=ts&"
export * from "./MemberDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=72e45768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e45768",
  null
  
)

export default component.exports